// The "Show working" switch (S157) of a conversation's card; the choice is shared (./showWorking).
import { Switch } from "rizzui";

import { useT } from "../i18n";
import { setShowWorking, useShowWorking } from "./showWorking";

export function ShowWorkingSwitch() {
  const t = useT().conversation.events;
  const show = useShowWorking();
  return (
    <Switch
      role="switch"
      size="sm"
      label={t.showWorking}
      title={t.showWorkingHint}
      labelClassName="text-[13px] text-gray-700"
      checked={show}
      onChange={() => setShowWorking(!show)}
      data-testid="show-working"
    />
  );
}
